import { type Ref, computed } from 'vue'

function getWidthInPixel(width: Ref, value: string) {
	let x = 0
	for (let unit of ['px', 'em', 'rem'])
			if (value.endsWith(unit))
				 x = unit === 'px'
					? Number(value.replace(unit ,''))
				 	: Number(value.replace(unit ,'')) * 16 //Math.ceil(Number(value.replace(unit ,'')) / 100 * width.value)
	return x
}

export const useScreen = (opts?: UseWindowSizeOptions) => {
	const styles = window.getComputedStyle(document.documentElement)
	let twScreens: object = {}
	for (const cssvar of ['--breakpoint-xs', '--breakpoint-sm', '--breakpoint-md', '--breakpoint-lg', '--breakpoint-xl', '--breakpoint-2xl', '--breakpoint-3xl', '--breakpoint-4xl', '--breakpoint-5xl', '--breakpoint-6xl', '--breakpoint-xl']) {
		const s = styles.getPropertyValue(cssvar)
		if (s)
			twScreens[cssvar.replace('--breakpoint-', '')] = s
	}

	const { width, height } = useWindowSize(opts)
	let screens: any = {
		width,
		height,
		breakpoints: {},
		current: computed(() => Object.keys(screens.breakpoints).find((k: string) => screens[k].value === true)),
		lt: {},
		lte: {},
		gt: {},
		gte: {},
		between(from:string, to:string) {
			return [this.gte[from], this.lte[to]].every(e => e.value)
		}
	}
	Object.values(twScreens)
		.sort((a, b) => getWidthInPixel(width, a) - getWidthInPixel(width, b))
		.forEach(w => {
			screens.breakpoints[Object.keys(twScreens).find(key => twScreens[key] === w)] = computed(()=> getWidthInPixel(width, w))
		})

	Object.keys(screens.breakpoints).forEach((name: string, idx: number) => {
		if (idx === 0) {
			screens[name] = computed(() =>
				width.value >= screens.breakpoints[name].value
				&& width.value < screens.breakpoints[Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === 1)].value
			)
			screens.lte[name] = computed(() =>
				width.value <= screens.breakpoints[
					Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === 1)
				].value
			)
			screens.gt[name] = computed(() =>
				width.value >= screens.breakpoints[
					Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === 1)
				].value
			)
		}
		else if (idx === Object.keys(screens.breakpoints).length-1) {
			screens[name] = computed(() => width.value >= screens.breakpoints[name].value)
			screens.lte[name] = computed(() =>  true)
			screens.gt[name] = computed(() => false )
		}
		else {
			screens[name] = computed(() =>
				width.value >= screens.breakpoints[name].value
				&& width.value < screens.breakpoints[
					Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === idx + 1)
				].value
			)
			screens.lte[name] = computed(() =>
				width.value < screens.breakpoints[
					Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === idx+1)
				].value
			)
			screens.gt[name] = computed(() =>
				width.value >= screens.breakpoints[
					Object.keys(screens.breakpoints).find((key: string, sidx: number) => sidx === idx+1)
				].value
			)
		}
		screens.lt[name] = computed(() => width.value < screens.breakpoints[name].value)
		screens.gte[name] = computed(() => width.value >= screens.breakpoints[name].value)
	})
	return reactive(screens)
}
